import { render } from "./ContentFileListModalPrices.vue?vue&type=template&id=b62657cc"
import script from "./ContentFileListModalPrices.vue?vue&type=script&lang=js"
export * from "./ContentFileListModalPrices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__